import { Component } from "@angular/core";

@Component({
	selector: "stacked-card",
	templateUrl: "./stacked-cards.component.html",
	styleUrls: ["./stacked-cards.component.scss"]
})
export class StackedCardsComponent {}



// WEBPACK FOOTER //
// ./src/app/shared/components/cards/stacked-cards/stacked-cards.component.ts